import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SEOHead = ({ pageType = "website", brandId = null }) => {
  const [schemaData, setSchemaData] = useState(null);

  useEffect(() => {
    fetchSchemaData();
    fetchSiteVerification();
  }, [pageType, brandId]);

  const fetchSiteVerification = async () => {
    try {
      const res = await axios.get(`${API}/targeting/settings`);
      const code = (res.data?.google_site_verification || "").trim();
      // Remove old tag (if value changed in admin)
      const old = document.querySelector('meta[name="google-site-verification"]');
      if (old) old.remove();
      if (code) {
        const meta = document.createElement("meta");
        meta.name = "google-site-verification";
        meta.content = code;
        document.head.appendChild(meta);
      }
    } catch (e) {
      // ignore - non-critical
    }
  };

  const fetchSchemaData = async () => {
    try {
      if (pageType === "brand" && brandId) {
        const res = await axios.get(`${API}/brand-schema/${brandId}`);
        setSchemaData(res.data);
      } else {
        const res = await axios.get(`${API}/schema.json`);
        setSchemaData(res.data);
      }
    } catch (error) {
      console.error("Error fetching schema data:", error);
    }
  };

  useEffect(() => {
    if (!schemaData) return;

    // Remove existing schema scripts
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());

    // Add new schema scripts
    if (pageType === "brand") {
      // Single brand schema
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schemaData);
      document.head.appendChild(script);
    } else {
      // Website + Organization schemas
      if (schemaData.website) {
        const websiteScript = document.createElement("script");
        websiteScript.type = "application/ld+json";
        websiteScript.textContent = JSON.stringify(schemaData.website);
        document.head.appendChild(websiteScript);
      }
      
      if (schemaData.organization) {
        const orgScript = document.createElement("script");
        orgScript.type = "application/ld+json";
        orgScript.textContent = JSON.stringify(schemaData.organization);
        document.head.appendChild(orgScript);
      }
    }

    return () => {
      // Cleanup on unmount
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => script.remove());
    };
  }, [schemaData, pageType]);

  return null; // This component doesn't render anything visible
};

export default SEOHead;
